import React, { PureComponent } from "react"
import ReactDOM from "react-dom"
import * as i18n from "tb-i18n"
import { getVideoData } from "../homepage.module"
import { Modal } from "../../component/modal"
import { getRegisterUrl } from "../homepage.module"
const styles = require("./main.styl")
const videoStyles = require("./video.styl")

interface Props {}

interface State {
    phoneNumber: string
    isVideoShow: boolean
    videoDuration: number
}

export default class IntroScreen extends PureComponent<Props, State> {
    private videoRef: Element

    constructor(prop) {
        super(prop)
        this.state = {
            phoneNumber: "",
            isVideoShow: false,
            videoDuration: 0
        }
    }
    render() {
        const refFn = ref => {
            this.videoRef = ReactDOM.findDOMNode(ref) as Element
        }
        return (
            <section className={ styles["intro-screen"] }>
                <div className="intro-screen-intro">
                    <h1 className="intro-screen-intro-title">
                        {i18n.get("homepage.hero.title")}
                    </h1>
                    <div className="intro-screen-intro-detail">
                        {i18n.get("homepage.hero.desc")}
                    </div>
                    <a
                        className="intro-screen-intro-btn btn btn-gradient-blue free-signup"
                        href={ getRegisterUrl("home") }
                        target="_blank"
                    >
                        {i18n.get("homepage.register.button")}
                    </a>
                </div>
                <button
                    className="intro-screen-download-button"
                    onClick={ this.onClickDownload }
                >
                    {i18n.get("homepage.apps.download.link.app")}
                </button>
                <div
                    className="intro-screen-media"
                    style={{ backgroundImage: `url(${getVideoData().poster})` }}
                >
                    {/* { this.renderButton() } */}
                </div>
                <Modal
                    opened={ this.state.isVideoShow }
                    onHide={ this.onModalHide }
                >
                    <div className={ videoStyles["video-containter"] }>
                        <div className={ videoStyles["video-content"] }>
                            <video ref={ refFn } autoPlay={ true } controls={ true }>
                                <source
                                    src={ getVideoData().src }
                                    type="video/mp4"
                                />
                            </video>
                        </div>
                    </div>
                </Modal>
            </section>
        )
    }
    renderButton() {
        return (
            <div className="intro-screen-media-button" onClick={ this.showModal }>
                <div className="intro-screen-media-button-icon" />
                <div className="intro-screen-media-button-text">
                    <div> {i18n.get("homepage.playVideo")} </div>
                    <div>1'03</div>
                </div>
            </div>
        )
    }
    showModal = () => {
        this.setState({ isVideoShow: true })
    }
    onModalHide = () => {
        this.setState({ isVideoShow: false })
    }
    onClickDownload = () => {
        window.location.href = "/apps"
    }
}
